<template>
  <a-base-component :subscribed_modules="subscribed_modules">
    <template v-slot:default>
      <div v-show="tab_view === 'table'">
        <div
          class="d-flex justify-end align-center mb-4 mt-4"
          style="width:100%"
        >
          <div
            class="rounded-pill white d-flex align-center justify-space-between py-1 px-1"
            style="height: 100%; position: relative;"
          >
            <a-label class="px-4">{{ $t("comparative") }}:</a-label>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  rounded
                  fab
                  :color="kpi_mode === 'relative' ? 'secondary' : 'white'"
                  @click="setKpiMode('relative')"
                  class="ml-2"
                >
                  <v-icon
                    small
                    :color="kpi_mode === 'relative' ? 'white' : 'black'"
                  >
                    mdi-percent-outline
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("percentage") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  rounded
                  fab
                  :color="kpi_mode === 'absolute' ? 'secondary' : 'white'"
                  @click="setKpiMode('absolute')"
                  class="ml-2"
                >
                  <v-icon
                    small
                    :color="kpi_mode === 'absolute' ? 'white' : 'black'"
                  >
                    mdi-counter
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("absolute") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  rounded
                  fab
                  :color="kpi_mode === 'hide_vs' ? 'secondary' : 'white'"
                  @click="setKpiMode('hide_vs')"
                  class="ml-2"
                >
                  <v-icon
                    small
                    :color="kpi_mode === 'hide_vs' ? 'white' : 'black'"
                  >
                    mdi-circle-off-outline
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("hide_vs") }}</span>
            </v-tooltip>
          </div>
          <div class="mr-0 ml-2">
            <div
              class="rounded-pill white d-flex align-center justify-space-between py-1 px-1"
              style="height: 100%; position: relative;"
            >
              <a-label class="px-4">Vista:</a-label>
              <template>
                <v-tooltip
                  bottom
                  v-for="(group, index) in year_sales_groups_names"
                  :key="'group_' + index"
                >
                  <template v-slot:activator="{ on, attrs }" v-if="group">
                    <v-chip
                      v-bind="attrs"
                      v-on="on"
                      small
                      :color="group.isActive ? 'secondary' : 'transparent'"
                      :text-color="group.isActive ? 'white' : 'black'"
                      @click="toggleGroup(group)"
                      class="mr-2 my-2"
                    >
                      {{ getGroupLabel(group.group) }}
                    </v-chip>
                  </template>
                  <span>{{ getGroupTooltip(group.group) }}</span>
                </v-tooltip>
              </template>
            </div>
          </div>
          <div
            v-if="is_spot_date_active"
            class="ml-2"
            style="max-width: 180px;"
          >
            <!-- És l'últim camp de la dreta: amb "left" el menú penja de la
                 vora dreta del camp i s'obre cap a l'esquerra, i sense
                 min-width="auto" Vuetify pot corregir el desbordament -->
            <v-menu
              ref="spot_date_menu"
              transition="scale-transition"
              offset-y
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="spot_date_formatted"
                  v-bind="attrs"
                  v-on="on"
                  :placeholder="$t('custom_date')"
                  prepend-inner-icon="mdi-calendar"
                  background-color="white"
                  class="pt-0 mt-0 year-sales-spot-date-input"
                  height="40"
                  readonly
                  rounded
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="spot_date"
                :max="max_spot_date"
                no-title
                scrollable
              >
              </v-date-picker>
            </v-menu>
          </div>
        </div>
        <a-rms-year-sales-table
          :configYearSalesTable="configYearSalesTable"
          :monthsValues="monthsValues"
          :quartersValues="quartersValues"
          :yearValues="yearValues"
          :kpiMode="kpi_mode"
        >
        </a-rms-year-sales-table>
      </div>
      <a-rms-year-sales-charts v-show="tab_view === 'chart'" />
    </template>
    <template v-slot:loading>
      <v-card>
        <v-card-text>
          <v-skeleton-loader
            v-for="i in 12"
            :key="i"
            type="card"
            height="70"
            class="elevation-0 mb-2"
          >
          </v-skeleton-loader>
        </v-card-text>
      </v-card>
    </template>
  </a-base-component>
</template>

<script>
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import aBaseComponent from "@/components/aBaseComponent";
import aRmsYearSalesTable from "@/components/rms/clicktotravel/aRmsYearSalesTable.vue";
import aRmsYearSalesCharts from "@/components/rms/clicktotravel/aRmsYearSalesCharts.vue";
import aLabel from "@/components/aLabel.vue";
import { getSpotDateLabel } from "@/utils.js";

const config_year_sales_table = {
  "": {
    columns: {
      date: {}
    },
    icon: null
  },
  otb: {
    columns: {
      occupancy: { kpi: "occupancy", block: "otb" },
      adr: { kpi: "adr", block: "otb" },
      revpar: { kpi: "revpar", block: "otb" },
      room_revenue: { kpi: "room_revenue", block: "otb" }
    }
  },
  stly: {
    columns: {
      occupancy: { kpi: "occupancy", block: "stly" },
      adr: { kpi: "adr", block: "stly" },
      revpar: { kpi: "revpar", block: "stly" },
      room_revenue: { kpi: "room_revenue", block: "stly" }
    }
  },
  ly: {
    columns: {
      occupancy: { kpi: "occupancy", block: "ly" },
      adr: { kpi: "adr", block: "ly" },
      revpar: { kpi: "revpar", block: "ly" },
      room_revenue: { kpi: "room_revenue", block: "ly" }
    }
  },
  bud: {
    columns: {
      occupancy: { kpi: "occupancy", block: "bud" },
      adr: { kpi: "adr", block: "bud" },
      revpar: { kpi: "revpar", block: "bud" },
      room_revenue: { kpi: "room_revenue", block: "bud" }
    }
  },
  spot_date: {
    columns: {
      occupancy: { kpi: "occupancy", block: "spot_date" },
      adr: { kpi: "adr", block: "spot_date" },
      revpar: { kpi: "revpar", block: "spot_date" },
      room_revenue: { kpi: "room_revenue", block: "spot_date" }
    }
  }
  /* forecast: {
    columns: {
      occupancy: { kpi: "occupancy", block: "forecast" },
      adr: { kpi: "adr", block: "forecast" },
      revpar: { kpi: "revpar", block: "forecast" },
      room_revenue: { kpi: "room_revenue", block: "forecast" }
    }
  } */
};

// Els grups de columnes disponibles a la vista. "spot_date" (comparativa a
// fecha) ve desactivat per defecte perquè necessita que l'usuari triï una data.
function getDefaultGroups() {
  return Object.keys(config_year_sales_table)
    .map(group => {
      return {
        group: group,
        icon: config_year_sales_table[group].icon,
        isActive: group !== "spot_date"
      };
    })
    .filter(g => g.group !== "");
}

export default {
  name: "a-rms-year-sales",
  components: {
    aBaseComponent,
    aLabel,
    aRmsYearSalesTable,
    aRmsYearSalesCharts
  },
  props: {
    event_period: {
      type: Array,
      default: () => []
    },
    tab_view: {
      type: String,
      default: "table"
    }
  },
  data: () => ({
    title: "",
    subscribed_modules: [
      "rms_kpis_year_sales_months",
      "rms_kpis_year_sales_quarters",
      "rms_kpis_year_sales_year",
      "rms_year_sales_monthly_graph",
      "rms_year_sales_table",
      "rms_dashboard_annual_kpis"
    ],
    year_sales_groups_names: getDefaultGroups(),
    kpi_mode: "relative",
    spot_date_selected: ""
  }),
  watch: {
    current_hotel() {
      this.setInitFilters();
    },
    user_settings() {
      if (this.user_settings) {
        this.setInitFilters();
      }
    }
    /* monthsValues() {
      this.monthsGraphData = {
        kpis: this.series_monthly,
        labels: this.labels_monthly
      };
    },
    quartersValues() {
      this.quartersGraphData = {
        kpis: this.series_quarterly,
        labels: this.labels_quarterly
      };
    } */
  },
  methods: {
    setKpiMode(mode) {
      this.kpi_mode = mode;
      this.saveUserSettings();
    },
    toggleGroup(group) {
      group.isActive = !group.isActive;
      if (group.group === "spot_date") {
        // La comparativa "a fecha" no té sentit sense data: si s'activa i
        // encara no n'hi ha cap de guardada, en proposem una per defecte
        if (group.isActive && !this.spot_date_selected) {
          this.spot_date_selected = Vue.moment()
            .subtract(1, "month")
            .format("YYYY-MM-DD");
        }
        this.syncSpotDate();
      }
      this.saveUserSettings();
    },
    // Només demanem les dades "a fecha" al backend si les columnes es mostren
    syncSpotDate() {
      this.$store.dispatch(
        "setRmsYearSalesSpotDate",
        this.is_spot_date_active ? this.spot_date_selected : ""
      );
    },
    getGroupTooltip(group) {
      return group === "spot_date"
        ? getSpotDateLabel(this.spot_date_selected)
        : this.$t(group);
    },
    getGroupLabel(group) {
      return group === "spot_date" ? getSpotDateLabel() : group;
    },
    setInitFilters() {
      if (!this.current_hotel) return;

      // Sempre partim dels valors per defecte: així en canviar d'hotel no
      // s'arrosseguen els filtres de l'anterior
      this.year_sales_groups_names = getDefaultGroups();
      this.kpi_mode = "relative";
      this.spot_date_selected = "";

      const user_data =
        this.user_settings && this.user_settings.rms_year_sales
          ? this.user_settings.rms_year_sales[this.current_hotel.id]
          : null;

      if (user_data) {
        if (user_data.comparative) {
          this.kpi_mode = user_data.comparative;
        }
        if (Array.isArray(user_data.year_sales_groups)) {
          const stored = user_data.year_sales_groups.reduce((acc, cur) => {
            acc[cur.group] = cur;
            return acc;
          }, {});
          this.year_sales_groups_names = this.year_sales_groups_names.map(
            group =>
              stored[group.group]
                ? { ...group, isActive: stored[group.group].isActive }
                : group
          );
        }
        this.spot_date_selected = user_data.spot_date || "";
      }
      this.syncSpotDate();
    },
    saveUserSettings() {
      if (!this.current_hotel) return;
      this.$store.dispatch("setRmsYearSalesUserSettings", {
        settings: this.year_sales_user_settings,
        hotel_id: this.current_hotel.id
      });
    }
  },
  computed: {
    monthsValues() {
      return this.rms.kpis_year_sales_months;
    },
    quartersValues() {
      const quarters = {
        q1: this.rms.kpis_year_sales_q1,
        q2: this.rms.kpis_year_sales_q2,
        q3: this.rms.kpis_year_sales_q3,
        q4: this.rms.kpis_year_sales_q4
      };
      return { ...quarters };
    },
    yearValues() {
      return this.rms.kpis_year_sales_year;
    },
    configYearSalesTable() {
      return {
        "": config_year_sales_table[""],
        ...this.year_sales_groups_names.reduce((acc, cur) => {
          if (cur.isActive) {
            acc[cur.group] = config_year_sales_table[cur.group];
          }
          return acc;
        }, {})
      };
    },
    is_spot_date_active() {
      const group = this.year_sales_groups_names.find(
        g => g.group === "spot_date"
      );
      return !!group && group.isActive;
    },
    max_spot_date() {
      return Vue.moment().format("YYYY-MM-DD");
    },
    spot_date: {
      get() {
        return this.spot_date_selected;
      },
      set(value) {
        this.spot_date_selected = value;
        this.syncSpotDate();
        this.saveUserSettings();
      }
    },
    spot_date_formatted: {
      get() {
        return this.spot_date
          ? Vue.moment(this.spot_date).format("DD/MM/YYYY")
          : "";
      }
    },
    year_sales_user_settings() {
      return {
        comparative: this.kpi_mode,
        spot_date: this.spot_date,
        year_sales_groups: this.year_sales_groups_names.map(g => ({
          group: g.group,
          isActive: g.isActive
        }))
      };
    },
    /* monthsGraphData: {
      get() {
        return this.rms.kpis_year_sales_months_graph;
      },
      set(value) {
        this.$store.commit("GET_DATASET", {
          dataset: "kpis_year_sales_months_graph",
          data: value
        });
      }
    },
    quartersGraphData: {
      get() {
        return this.rms.kpis_year_sales_quarters_graph;
      },
      set(value) {
        this.$store.commit("GET_DATASET", {
          dataset: "kpis_year_sales_quarters_graph",
          data: value
        });
      }
    }, */
    /* series_monthly() {
      return this.keys_monthly.reduce((acc, key) => {
        Object.keys(this.monthsValues[key].otb).forEach(kpi => {
          if (!acc[kpi]) {
            acc[kpi] = {
              otb: [],
              stly: []
            };
          }
          acc[kpi].otb.push(this.monthsValues[key].otb[kpi]);
          acc[kpi].stly.push(this.monthsValues[key].stly[kpi]);
        });
        return acc;
      }, {});
    },
    series_quarterly() {
      return this.labels_quarterly.reduce((acc, key) => {
        Object.keys(this.quartersValues[key].otb).forEach(kpi => {
          if (!acc[kpi]) {
            acc[kpi] = {
              otb: [],
              stly: []
            };
          }
          acc[kpi].otb.push(this.quartersValues[key].otb[kpi]);
          acc[kpi].stly.push(this.quartersValues[key].stly[kpi]);
        });
        return acc;
      }, {});
    }, */
    /* keys_monthly() {
      return Object.keys(this.monthsValues);
    },
    labels_monthly() {
      return this.keys_monthly.map(key =>
        Vue.moment(`${key}-01`).format("MMM")
      );
    }, */
    /* labels_quarterly() {
      return Object.keys(this.quartersValues);
    }, */
    ...mapState({
      rms: state => state.rms
      //available_rate_extractions: state => state.rate.available_rate_extractions
    }),
    ...mapGetters({
      current_hotel: "current_hotel",
      user_settings: "getUserSettings"
    })
  },
  mounted() {
    this.setInitFilters();
  }
};
</script>
<style lang="scss">
.v-list--dense .v-list-item {
  min-height: 33px;
}
.v-date-picker-title__date {
  font-size: 16px;
}
.cols7 {
  width: calc(100% / 7);
  max-width: calc(100% / 7);
  flex-basis: calc(100% / 7);
}
$height: 19px;
.a-rms-day {
  font-size: 11px;
  line-height: height;
  text-align: right;
  &:focus::before {
    background: white;
  }

  .a-rms-day-row-day {
    height: $height;
    font-weight: 600;
    text-transform: uppercase;
    color: #444444;
    letter-spacing: -0.5px;
  }
  .a-rms-day-row-header {
    font-size: 11px;
    font-weight: 500;
    color: #666666;
    text-transform: uppercase;
    height: $height;
    overflow: hidden;
    letter-spacing: -0.5px;
  }
  .a-rms-day-row {
    height: $height;
    overflow: hidden;
    display: flex;
    align-items: center;
  }
  .a-rms-day-row-resume {
    height: $height;
    font-weight: 600;
    overflow: hidden;
  }
}
.day_details_mini {
  position: fixed;
  width: 90%;
  bottom: 20px;
  border-radius: 15px;
  overflow: hidden;
  z-index: 20;
}
.year-sales-spot-date-input {
  .v-input__prepend-inner {
    margin-top: 10px;
  }
}
</style>
